import api from "../utils/api";
import apiBlob from "../utils/apiBlob";

// const FORCE_FAIL = true; // flip this off when done testing
// if (FORCE_FAIL) {
//   throw new Error("Forced failure for testing");
// }

///Auth
export async function login(user: string, password: string) {
  const response = await Promise.all([api.post("/users/auth", { email: user, password: password })]);
  return response;
}

export async function fetchUserSecret() {
  const response = await Promise.all([api.get("/users/totpsecret")]);
  return response;
}

export async function verifyTwoFactor(totpCode: string, totpSecret?: string, default2fa?: string) {
  var obj = {};

  if (totpSecret) {
    obj = {
      code: totpCode,
      secret: totpSecret,
      default: default2fa,
    };
  } else {
    obj = { code: totpCode, default: default2fa };
  }
  const response = await Promise.all([api.post("/users/verifytotp", obj)]);
  return response;
}

export async function sendMultiFactorCode(emailPhone: string, type: string, secret?: string) {
  const response = await Promise.all([api.post(`/users/sendmultifactorcode`, { emailPhone, type, secret })]);
  return response;
}

export async function logout() {
  const response = await Promise.all([
    api
      .post("/users/logout")
      .then((res: any) => {
        localStorage.removeItem("auth");
        localStorage.removeItem("expiration");
      })
      .catch(function (error) {
        console.log(error);
      }),
  ]);
  return response;
}

export async function sendPasswordReset(email: string) {
  const response = await Promise.all([api.post(`/users/sendpasswordreset`, { emailPhone: email, mode: "desktop", type: "email" })]);
  return response;
}

export async function resetPassword(resetCode: string, emailPhone: string, password: string) {
  const response = await Promise.all([
    api.post(`/users/resetpassword`, { resetCode: resetCode, emailPhone: emailPhone, password: password }),
  ]);
  return response;
}

export async function switchOrg(org: string) {
  const response = await Promise.all([api.post("/users/authorgswitch", { new_org_id: org })]);
  return response;
}

///Organization
export async function fetchOrganizations(myOrgs?: number[] | null) {
  var path = "/organizations";
  if (myOrgs) {
    path = `/organizations?myOrgs=${myOrgs}`;
  }
  const response = await Promise.all([
    api.get(path).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchOrganization(id?: string) {
  const response = await Promise.all([
    api.get(`/organizations/${id}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function patchOrganization(o: object, id?: string) {
  const response = await Promise.all([api.patch(`/organizations/${id}`, o)]);
  return response;
}

//Organization Goal Templates
export async function fetchGoalTemplates(orgId?: string) {
  const response = await Promise.all([
    api.get(`/organizations/${orgId}/goals`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchGoalTemplate(orgId?: string, goalId?: string) {
  const response = await Promise.all([
    api.get(`/organizations/${orgId}/goals/${goalId}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function patchGoalTemplate(goal: object, orgId?: string, goalId?: string) {
  const response = await Promise.all([api.patch(`/organizations/${orgId}/goals/${goalId}`, goal)]);
  return response;
}

export async function postGoalTemplate(goal: object, orgId?: string) {
  const response = await Promise.all([api.post(`/organizations/${orgId}/goals`, goal)]);
  return response;
}

export async function deleteGoalTemplate(orgId?: string, goalId?: string) {
  const response = await Promise.all([api.delete(`/organizations/${orgId}/goals/${goalId}`)]);
  return response;
}

//Organization Task Templates
export async function patchTaskTemplate(task: object, orgId?: string, goalId?: string, taskId?: string) {
  const response = await Promise.all([api.patch(`/organizations/${orgId}/goals/${goalId}/tasks/${taskId}`, task)]);
  return response;
}

export async function postTaskTemplate(task: object, orgId?: string, goalId?: string) {
  const response = await Promise.all([api.post(`/organizations/${orgId}/goals/${goalId}/tasks`, task)]);
  return response;
}

export async function deleteTaskTemplate(orgId?: string, goalId?: string, taskId?: string) {
  const response = await Promise.all([api.delete(`/organizations/${orgId}/goals/${goalId}/tasks/${taskId}`)]);
  return response;
}

export async function reorderTaskTemplate(orgId?: string, goalId?: string, newOrder?: any[]) {
  const response = await Promise.all([api.post(`/organizations/${orgId}/goals/${goalId}/tasks/reorder`, { order: newOrder })]);
  return response;
}

///Goal Categories
export async function fetchGoalCategories() {
  const response = await Promise.all([api.get(`/goalcategories`).catch((error) => {})]);
  return response;
}

export async function postGoalCategory(g: object) {
  const response = await Promise.all([api.post(`/goalcategories`, g)]);
  return response;
}

export async function patchGoalCategory(g: object, id?: string) {
  const response = await Promise.all([api.patch(`/goalcategories/${id}`, g)]);
  return response;
}

export async function deleteGoalCategory(id?: string) {
  const response = await Promise.all([api.delete(`/goalcategories/${id}`)]);
  return response;
}

//Organization Household Programs
export async function fetchPrograms() {
  const response = await Promise.all([
    api.get(`/programs`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function patchProgram(prog: object, programId: string) {
  const response = await Promise.all([api.patch(`/programs/${programId}`, prog)]);
  return response;
}

export async function postProgram(prog: object) {
  const response = await Promise.all([api.post(`/programs`, prog)]);
  return response;
}

export async function deleteProgram(programId: string) {
  const response = await Promise.all([api.delete(`/programs/${programId}`)]);
  return response;
}

//Organization Household Program Levels
export async function postProgramLevel(programId: string, name: string) {
  const response = await Promise.all([
    api.post(`/program-levels`, { program_id: programId, name: name }).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
      throw error;
    }),
  ]);
  return response;
}

export async function fetchProgramLevels(programIds: any[]) {
  const response = await Promise.all([
    api.post(`/program-levels/get`, { program_ids: programIds }).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
      throw error;
    }),
  ]);
  return response;
}

export async function patchProgramLevel(id: string, name: string) {
  const response = await Promise.all([
    api.patch(`/program-levels`, { id: id, name: name }).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
      throw error;
    }),
  ]);
  return response;
}

export async function deleteProgramLevel(id: string) {
  const response = await Promise.all([
    api.delete(`/program-levels/${id}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
      throw error;
    }),
  ]);
  return response;
}

export async function reorderProgramLevels(newOrder: any[]) {
  const response = await Promise.all([api.patch("/program-levels/reorder", { order: newOrder })]);
  return response;
}

//Organization Household Departments
export async function fetchDepartments() {
  const response = await Promise.all([
    api.get(`/departments`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function patchDepartment(dept: object, deptId: string) {
  const response = await Promise.all([api.patch(`/departments/${deptId}`, dept)]);
  return response;
}

export async function postDepartment(dept: object) {
  const response = await Promise.all([api.post(`/departments`, dept)]);
  return response;
}

export async function deleteDepartment(deptId: string) {
  const response = await Promise.all([api.delete(`/departments/${deptId}`)]);
  return response;
}

//Organization Household Jobs
export async function fetchJobs() {
  const response = await Promise.all([
    api.get(`/jobs`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function patchJob(job: object, deptId: string, jobId: string) {
  const response = await Promise.all([api.patch(`/departments/${deptId}/jobs/${jobId}`, job)]);
  return response;
}

export async function postJob(job: object, deptId: string) {
  const response = await Promise.all([api.post(`/departments/${deptId}/jobs`, job)]);
  return response;
}

export async function deleteJob(deptId: string, jobId: string) {
  const response = await Promise.all([api.delete(`/departments/${deptId}/jobs/${jobId}`)]);
  return response;
}

//Organization Household Fields
export async function fetchFields() {
  const response = await Promise.all([
    api.get(`/fields`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function patchField(field: object, fieldId: string) {
  const response = await Promise.all([api.patch(`/fields/${fieldId}`, field)]);
  return response;
}

export async function postField(field: object) {
  const response = await Promise.all([api.post(`/fields`, field)]);
  return response;
}

export async function deleteField(fieldId: string) {
  const response = await Promise.all([api.delete(`/fields/${fieldId}`)]);
  return response;
}

export async function reorderFields(newOrder: any[]) {
  const response = await Promise.all([api.post("/fields/reorder", { order: newOrder })]);
  return response;
}

//Organization Household Field Values
export async function patchFieldValue(field: object, fieldValueId: string) {
  const response = await Promise.all([api.patch(`/field-values/${fieldValueId}`, field)]);
  return response;
}

export async function postFieldValue(field: object) {
  const response = await Promise.all([api.post(`/field-values`, field)]);
  return response;
}

//Organization Note Types
export async function fetchNoteTypes() {
  const response = await Promise.all([api.get(`/notetypes`)]);
  return response;
}

export async function postNoteType(type: object) {
  const response = await Promise.all([api.post(`/notetypes`, type)]);
  return response;
}

export async function patchNoteType(n: object, id?: string | number) {
  const response = await Promise.all([api.patch(`/notetypes/${id}`, n)]);
  return response;
}

export async function deleteNoteType(id: string) {
  const response = await Promise.all([api.delete(`/notetypes/${id}`)]);
  return response;
}

export async function postNoteTypeField(field: object, typeId?: string) {
  const response = await Promise.all([api.post(`/notetypes/${typeId}/fields`, field)]);
  return response;
}

export async function fetchNoteTypeFields(typeId?: string) {
  const response = await Promise.all([
    api.get(`/notetypes/${typeId}/fields`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function patchNoteTypeField(field: object, typeId: string, id: string) {
  const response = await Promise.all([api.patch(`/notetypes/${typeId}/fields/${id}`, field)]);
  return response;
}

export async function deleteNoteTypeField(typeId: string, id: string) {
  const response = await Promise.all([api.delete(`/notetypes/${typeId}/fields/${id}`)]);
  return response;
}

//Organization Note Type Field Choices
export async function postFieldChoice(fc: object, typeId: string, fieldId: string) {
  const response = await Promise.all([api.post(`/notetypes/${typeId}/fields/${fieldId}/choices`, fc)]);
  return response;
}

export async function fetchFieldChoices(typeId?: string, id?: string) {
  const response = await Promise.all([
    api.get(`/notetypes/${typeId}/fields/${id}/choices`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function patchFieldChoice(fc: object, typeId: string, fieldId: string, id: string) {
  const response = await Promise.all([api.patch(`/notetypes/${typeId}/fields/${fieldId}/choices/${id}`, fc)]);
  return response;
}

export async function deleteFieldChoice(typeId: string, fieldId: string, id: string) {
  const response = await Promise.all([api.delete(`/notetypes/${typeId}/fields/${fieldId}/choices/${id}`)]);
  return response;
}

///Organization Custom Assessments
export async function fetchFieldSets() {
  const response = await Promise.all([
    api.get(`/assessment-field-sets`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function postAssessmentType(assess: object) {
  const response = await Promise.all([api.post(`/assessmenttypes`, assess)]);
  return response;
}

export async function patchAssessmentType(a: object, id?: string | number) {
  const response = await Promise.all([api.patch(`/assessmenttypes/${id}`, a)]);
  return response;
}

export async function deleteAssessmentType(id: string) {
  const response = await Promise.all([api.delete(`/assessmenttypes/${id}`)]);
  return response;
}

export async function postAssessmentTypeQuestion(q: object, typeId: string) {
  const response = await Promise.all([api.post(`/assessmenttypes/${typeId}/questions`, q)]);
  return response;
}

export async function patchAssessmentTypeQuestion(q: object, typeId: string, id: string) {
  const response = await Promise.all([api.patch(`/assessmenttypes/${typeId}/questions/${id}`, q)]);
  return response;
}

export async function deleteAssessmentTypeQuestion(typeId: string, id: string) {
  const response = await Promise.all([api.delete(`/assessmenttypes/${typeId}/questions/${id}`)]);
  return response;
}

export async function reorderAssessmentTypeQuestion(newOrder: any[], typeId: string) {
  const response = await Promise.all([api.post(`/assessmenttypes/${typeId}/questions/reorder`, { order: newOrder })]);
  return response;
}

///Announcements
export async function fetchAnnouncements() {
  const response = await Promise.all([
    api.get(`/announcements`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchAnnouncement(id?: string) {
  const response = await Promise.all([api.get(`/announcements/${id}`)]);
  return response;
}

export async function patchAnnouncement(c: object, id?: string) {
  const response = await Promise.all([api.patch(`/announcements/${id}`, c)]);
  return response;
}

export async function postAnnouncement(c: object) {
  const response = await Promise.all([api.post(`/announcements`, c)]);
  return response;
}

export async function deleteAnnouncement(id?: string) {
  const response = await Promise.all([api.delete(`/announcements/${id}`)]);
  return response;
}

export async function sendAnnouncement(c: object, id?: string) {
  const response = await Promise.all([api.post(`/announcements/${id}/send`, c)]);
  return response;
}

///Users
export async function fetchUsers() {
  const response = await Promise.all([
    api.get(`/users`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchUser(id?: string) {
  const response = await Promise.all([api.get(`/users/${id}`)]);
  return response;
}

export async function fetchCMUsers() {
  const response = await Promise.all([api.get(`/users/casemanager`)]);
  return response;
}

export async function fetchFamilyUsers() {
  const response = await Promise.all([api.get(`/users/family`)]);
  return response;
}

export async function fetchSupportUsers() {
  const response = await Promise.all([api.get(`/users/support`)]);
  return response;
}

export async function patchUser(user: object, id?: string) {
  const response = await Promise.all([api.patch(`/users/${id}`, user)]);
  return response;
}

export async function postUser(user: object) {
  const response = await Promise.all([api.post(`/users`, user)]);
  return response;
}

export async function deleteUser(id?: string) {
  const response = await Promise.all([api.delete(`/users/${id}`)]);
  return response;
}

///Cases
export async function fetchCases() {
  const response = await Promise.all([
    api.get(`/cases`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchCase(id?: string) {
  const response = await Promise.all([api.get(`/cases/${id}`)]);
  return response;
}

//cases that were active in a window of time
export async function fetchCaseRange(startDate: string, endDate: string) {
  const response = await Promise.all([api.get(`/cases?startDate=${startDate}&endDate=${endDate}`)]);
  return response;
}

export async function patchCase(c: object, id?: string) {
  const response = await Promise.all([api.patch(`/cases/${id}`, c)]);
  return response;
}

export async function postCase(c: object) {
  const response = await Promise.all([api.post(`/cases`, c)]);
  return response;
}

export async function deleteCase(id?: string) {
  const response = await Promise.all([api.delete(`/cases/${id}`)]);
  return response;
}

export async function fetchCasesActivity() {
  const response = await Promise.all([
    api.get(`/activity`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

///Group
export async function fetchGroups() {
  const response = await Promise.all([
    api.get(`/groups`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchGroup(id?: string) {
  const response = await Promise.all([api.get(`/groups/${id}`)]);
  return response;
}

export async function patchGroup(c: object, id?: string) {
  const response = await Promise.all([api.patch(`/groups/${id}`, c)]);
  return response;
}

export async function postGroup(g: object) {
  const response = await Promise.all([api.post(`/groups`, g)]);
  return response;
}

export async function deleteGroup(id?: string) {
  const response = await Promise.all([api.delete(`/groups/${id}`)]);
  return response;
}

///Group Participants
export async function fetchGroupParticipants(id?: string) {
  const response = await Promise.all([api.get(`/groups/${id}/participants`)]);
  return response;
}

export async function postGroupParticipant(p: object, id?: string) {
  const response = await Promise.all([api.post(`/groups/${id}/participants`, p)]);
  return response;
}

export async function patchGroupParticipant(id?: string, partId?: string) {
  const response = await Promise.all([api.patch(`/groups/${id}/participants/${partId}`)]);
  return response;
}

export async function deleteGroupParticipant(id?: string, partId?: string) {
  const response = await Promise.all([api.delete(`/groups/${id}/participants/${partId}`)]);
  return response;
}

export async function fetchGroupPossibleParticipants(id?: string) {
  const response = await Promise.all([api.get(`/groups/${id}/participants/possible`)]);
  return response;
}

///Group Meetings
export async function fetchGroupMeetings(groupId?: string) {
  const response = await Promise.all([api.get(`/groups/${groupId}/meetings`)]);
  return response;
}

export async function postGroupMeetings(m: object, id?: string) {
  const response = await Promise.all([api.post(`/groups/${id}/meetings`, m)]);
  return response;
}

///Resources
export async function fetchAllResources() {
  const response = await Promise.all([api.get(`/resources`).catch((error) => {})]);
  return response;
}

export async function postResource(r: object) {
  const response = await Promise.all([api.post(`/resources`, r)]);
  return response;
}

export async function patchResource(r: object, id?: string) {
  const response = await Promise.all([api.patch(`/resources/${id}`, r)]);
  return response;
}

export async function deleteResource(id?: string) {
  const response = await Promise.all([api.delete(`/resources/${id}`)]);
  return response;
}

///Resource Types
export async function fetchResourceTypes() {
  const response = await Promise.all([api.get(`/resourcetypes`).catch((error) => {})]);
  return response;
}

///Resource Categories
export async function fetchResourceCategories() {
  const response = await Promise.all([api.get(`/resourcecategories`).catch((error) => {})]);
  return response;
}

export async function postResourceCategory(r: object) {
  const response = await Promise.all([api.post(`/resourcecategories`, r)]);
  return response;
}

export async function patchResourceCategory(r: object, id?: string) {
  const response = await Promise.all([api.patch(`/resourcecategories/${id}`, r)]);
  return response;
}

export async function deleteResourceCategory(id?: string) {
  const response = await Promise.all([api.delete(`/resourcecategories/${id}`)]);
  return response;
}

///Resource Assignments
export async function fetchCaseResources(id?: string) {
  const response = await Promise.all([api.get(`/user-cases/${id}/resources`).catch((error) => {})]);
  return response;
}

export async function fetchCaseResourceHistory(id?: string) {
  const response = await Promise.all([api.get(`/user-cases/${id}/resources/history`).catch((error) => {})]);
  return response;
}

export async function postResourceAssignment(r: object, id?: string) {
  const response = await Promise.all([api.post(`/user-cases/${id}/resources`, r)]);
  return response;
}

export async function patchResourceAssignment(r: object, id?: string, resourceId?: string) {
  const response = await Promise.all([api.patch(`/user-cases/${id}/resources/${resourceId}`, r)]);
  return response;
}

///Reports
export async function fetchReportDashboardCharts() {
  const response = await Promise.all([api.get(`/report-dashboard`).catch((error) => {})]);
  return response;
}

export async function postReportDashboardCharts(r: object) {
  const response = await Promise.all([api.post(`/report-dashboard`, r)]);
  return response;
}

export async function deleteReportDashboardCharts(id: number) {
  const response = await Promise.all([api.delete(`/report-dashboard/${id}`)]);
  return response;
}

export async function patchReportDashboardCharts(id?: string, size?: string) {
  const response = await Promise.all([api.patch(`/report-dashboard/${id}`, { col_size: size })]);
  return response;
}

export async function reorderReportDashboardCharts(newOrder: any[]) {
  const response = await Promise.all([api.patch("/report-dashboard", { order: newOrder })]);
  return response;
}

export async function fetchReportCharts() {
  const response = await Promise.all([api.get(`/report-charts`).catch((error) => {})]);
  return response;
}

export async function fetchReportLog(name: string) {
  const response = await Promise.all([
    api.get(`/reports/log?name=${name}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function postReportLog(r: object) {
  const response = await Promise.all([api.post(`/reports/log`, r)]);
  return response;
}

export async function fetchReportInteractions(startDate?: string, endDate?: string, summary: boolean = true) {
  if (!startDate || !endDate) {
    const response = await Promise.all([
      api.get(`/reports/interactions?summary=${summary}`).catch((error) => {
        if (error.response.status === 401) {
          logout().then((res: any) => {
            window.location.reload();
          });
        }
      }),
    ]);
    return response;
  } else {
    const response = await Promise.all([
      api.get(`/reports/interactions?startDate=${startDate}&endDate=${endDate}&summary=${summary}`).catch((error) => {
        if (error.response.status === 401) {
          logout().then((res: any) => {
            window.location.reload();
          });
        }
      }),
    ]);
    return response;
  }
}

export async function fetchReportGoals(startDate: string, endDate: string) {
  const response = await Promise.all([
    api.get(`/reports/goals?startDate=${startDate}&endDate=${endDate}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchReportTasks(startDate: string, endDate: string) {
  const response = await Promise.all([
    api.get(`/reports/tasks?startDate=${startDate}&endDate=${endDate}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchReportResources(startDate: string, endDate: string) {
  const response = await Promise.all([
    api.get(`/reports/resources?startDate=${startDate}&endDate=${endDate}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchReportAssessments(assessmentTypeId: string, startDate: string, endDate: string) {
  const response = await Promise.all([
    api.get(`/reports/assessments?assessmentTypeId=${assessmentTypeId}&startDate=${startDate}&endDate=${endDate}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

//not being called
export async function fetchReportWellBeing(startDate: string, endDate: string) {
  const response = await Promise.all([
    api.get(`/reports/wellbeing?startDate=${startDate}&endDate=${endDate}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchReportContinuum() {
  const response = await Promise.all([
    api.get(`/reports/continuum`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchReportShelterOccupancy(locationKind: string = "all") {
  const response = await Promise.all([
    api.get(`/reports/occupancy?filterLevel=org&locationKind=${locationKind}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchReportShelterIntakesExits() {
  const response = await Promise.all([
    api.get(`/reports/intakes-exits`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchReportPrograms() {
  const response = await Promise.all([
    api.get(`/reports/programs`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchReportJobs() {
  const response = await Promise.all([
    api.get(`/reports/jobs`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchPopulation(startDate: string, endDate: string) {
  const response = await Promise.all([
    api.get(`/reports/population?startDate=${startDate}&endDate=${endDate}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

///User Case Reports
export async function fetchUserCaseReportInteractions(startDate: string, endDate: string, id?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/reports/interactions?startDate=${startDate}&endDate=${endDate}&summary=true`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchUserCaseReportGoals(startDate: string, endDate: string, id?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/reports/goals?startDate=${startDate}&endDate=${endDate}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchUserCaseReportTasks(startDate: string, endDate: string, id?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/reports/tasks?startDate=${startDate}&endDate=${endDate}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchUserCaseReportAssessments(startDate: string, endDate: string, id?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/reports/assessments?startDate=${startDate}&endDate=${endDate}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchUserCaseReportWellBeing(startDate: string, endDate: string, id?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/reports/wellbeing?startDate=${startDate}&endDate=${endDate}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchUserCaseReportContinuum(id?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/reports/continuum`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

///User Cases
export async function fetchUserCasesFiltered(includeImage: boolean = false, status: string) {
  const response = await Promise.all([
    api.get(`/user-cases?includeImage=${includeImage}&status=${status}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchUserCasesLazy(status: string, limit?: number, offset?: number) {
  const response = await Promise.all([
    api.get(`/user-cases/lazy?status=${status}&per_page=${limit}&page=${offset}`).catch((error) => {
      if (error.response?.status === 401) {
        logout().then(() => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchUserCasesMy() {
  const response = await Promise.all([
    api.get(`/user-cases/my`).catch((error) => {
      if (error.response?.status === 401) {
        logout().then(() => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchUserCasesImages(familyIDs: any[] = [], memberIDs: any[] = []) {
  const payload = {
    userIDs: familyIDs,
    memberIDs: memberIDs,
  };
  const response = await Promise.all([
    api.post(`/user-cases/images`, payload).catch((error) => {
      if (error.response?.status === 401) {
        logout().then(() => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchUserCases(includeImage: boolean = false) {
  const response = await Promise.all([
    api.get(`/user-cases?includeImage=${includeImage}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchUserCase(id?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function patchUserCase(c: object, id?: string) {
  const response = await Promise.all([api.patch(`/user-cases/${id}`, c)]);
  return response;
}

///User Case Guardians
export async function fetchUserCaseGuardians(id?: string, deleted: boolean = false) {
  if (deleted) {
    const response = await Promise.all([
      api.get(`/user-cases/${id}/guardians?deleted=${deleted}`).catch((error) => {
        if (error.response.status === 401) {
          logout().then((res: any) => {
            window.location.reload();
          });
        }
      }),
    ]);
    return response;
  } else {
    const response = await Promise.all([
      api.get(`/user-cases/${id}/guardians`).catch((error) => {
        if (error.response.status === 401) {
          logout().then((res: any) => {
            window.location.reload();
          });
        }
      }),
    ]);
    return response;
  }
}

export async function patchGuardian(guardian: object, id?: string, guardianId?: string) {
  const response = await Promise.all([api.patch(`/user-cases/${id}/guardians/${guardianId}`, guardian)]);
  return response;
}

export async function postGuardian(guardian: object, id?: string) {
  const response = await Promise.all([api.post(`/user-cases/${id}/guardians`, guardian)]);
  return response;
}

export async function deleteGuardian(id?: string, guardianId?: string, exit?: object) {
  if (!exit) {
    exit = {};
  }
  const response = await Promise.all([api.post(`/user-cases/${id}/guardians/${guardianId}`, exit)]);
  return response;
}

export async function banGuardian(ban: object, id?: string, guardianId?: string) {
  const response = await Promise.all([api.patch(`/user-cases/${id}/guardians/${guardianId}`, ban)]);
  return response;
}

///User Case Meetings
export async function fetchUserCaseMeetings(id?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/meetings`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function postMeeting(meeting: object, id?: string) {
  const response = await Promise.all([api.post(`/user-cases/${id}/meetings`, meeting)]);
  return response;
}

export async function patchMeeting(meeting: object, id?: string, meetingId?: string) {
  const response = await Promise.all([api.patch(`/user-cases/${id}/meetings/${meetingId}`, meeting)]);
  return response;
}

export async function deleteMeeting(id?: string, meetingId?: string) {
  const response = await Promise.all([api.delete(`/user-cases/${id}/meetings/${meetingId}`)]);
  return response;
}

///User Case Members
export async function fetchUserCaseMembers(id?: string, deleted: boolean = false) {
  if (deleted) {
    const response = await Promise.all([
      api.get(`/user-cases/${id}/members?deleted=${deleted}`).catch((error) => {
        if (error.response.status === 401) {
          logout().then((res: any) => {
            window.location.reload();
          });
        }
      }),
    ]);
    return response;
  } else {
    const response = await Promise.all([
      api.get(`/user-cases/${id}/members`).catch((error) => {
        if (error.response.status === 401) {
          logout().then((res: any) => {
            window.location.reload();
          });
        }
      }),
    ]);
    return response;
  }
}

export async function fetchUserCaseMember(id?: string, memberId?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/members/${memberId}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function patchMember(member: object, id?: string, memberId?: string) {
  const response = await Promise.all([api.patch(`/user-cases/${id}/members/${memberId}`, member)]);
  return response;
}

export async function postMember(member: object, id?: string) {
  const response = await Promise.all([api.post(`/user-cases/${id}/members`, member)]);
  return response;
}

export async function deleteMember(id?: string, memberId?: string, exit?: object) {
  if (!exit) {
    exit = {};
  }
  const response = await Promise.all([api.post(`/user-cases/${id}/members/${memberId}`, exit)]);
  return response;
}

export async function banMember(ban: object, id?: string, memberId?: string) {
  const response = await Promise.all([api.patch(`/user-cases/${id}/members/${memberId}`, ban)]);
  return response;
}

///User Case Job Assignments
export async function fetchJobAssignments(id?: string) {
  const response = await Promise.all([api.get(`/user-cases/${id}/jobs`).catch((error) => {})]);
  return response;
}

export async function postJobAssignment(j: object, id?: string) {
  const response = await Promise.all([api.post(`/user-cases/${id}/jobs`, j)]);
  return response;
}

export async function patchJobAssignment(j: object, id?: string, jobAssignId?: string) {
  const response = await Promise.all([api.patch(`/user-cases/${id}/jobs/${jobAssignId}`, j)]);
  return response;
}

export async function deleteJobAssignment(id?: string, jobId?: string) {
  const response = await Promise.all([api.delete(`/user-cases/${id}/jobs/${jobId}`)]);
  return response;
}

///User Case Program Assignments
export async function postProgramAssignment(p: object, id?: string) {
  const response = await Promise.all([api.post(`/user-cases/${id}/programs`, p)]);
  return response;
}

export async function patchProgramAssignment(p: object, id?: string, programAssignId?: string) {
  const response = await Promise.all([api.patch(`/user-cases/${id}/programs/${programAssignId}`, p)]);
  return response;
}

//User Case Notes
export async function fetchNotes(id?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/notes`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchNotesLazy(id?: string, limit?: number, offset?: number) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/notes/lazy?per_page=${limit}&page=${offset}`).catch((error) => {
      if (error.response?.status === 401) {
        logout().then(() => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function postNote(note: object, id?: string) {
  const response = await Promise.all([api.post(`/user-cases/${id}/notes`, note)]);
  return response;
}

export async function patchNote(note?: object, id?: string, noteId?: string) {
  const response = await Promise.all([api.patch(`/user-cases/${id}/notes/${noteId}`, note)]);
  return response;
}

//User Case Notes Docs
export async function fetchNoteDocuments(id?: string, noteId?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/notes/${noteId}/documents`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchNoteDocumentDownload(id?: string, noteId?: string, docId?: string) {
  const response = await Promise.all([apiBlob.get(`/user-cases/${id}/notes/${noteId}/documents/${docId}/download`)]);
  return response;
}

export async function fetchNoteDocumentView(id?: string, noteId?: string, docId?: string) {
  const response = await Promise.all([apiBlob.get(`/user-cases/${id}/notes/${noteId}/documents/${docId}/view`)]);
  return response;
}

export async function postNoteDocument(name: string, data: string, id?: string, noteId?: string) {
  const response = await Promise.all([
    api.post(`/user-cases/${id}/notes/${noteId}/documents`, {
      name: name,
      data: data,
    }),
  ]);
  return response;
}

export async function deleteNoteDocument(id?: string, noteId?: string, docId?: string) {
  const response = await Promise.all([api.delete(`/user-cases/${id}/notes/${noteId}/documents/${docId}`)]);
  return response;
}

//User Case Notes Recordings
export async function fetchNoteRecordings(id?: string, noteId?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/notes/${noteId}/recordings`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchNoteRecordingData(id?: string, noteId?: string, recordingId?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/notes/${noteId}/recordings/${recordingId}/data`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function deleteNoteRecordings(id?: string, noteId?: string, recordingId?: string) {
  const response = await Promise.all([api.delete(`/user-cases/${id}/notes/${noteId}/recordings/${recordingId}`)]);
  return response;
}

export async function deleteNoteRecordingsTranscript(id?: string, noteId?: string, recordingId?: string) {
  const response = await Promise.all([api.delete(`/user-cases/${id}/notes/${noteId}/recordings/${recordingId}/transcript`)]);
  return response;
}

export async function uploadNoteRecordings(id?: string, noteId?: string, recordingId?: string) {
  const response = await Promise.all([api.post(`/user-cases/${id}/notes/${noteId}/recordings/${recordingId}/upload`)]);
  return response;
}

//User Case Transcripts
export async function fetchTranscript(id: string) {
  const response = await Promise.all([
    api.get(`/transcripts/${id}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

//User Case Documents
export async function fetchDocuments(id?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/documents`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchDocumentDownload(id?: string, docId?: string) {
  const response = await Promise.all([apiBlob.get(`/user-cases/${id}/documents/${docId}/download`)]);
  return response;
}

export async function fetchDocumentView(id?: string, docId?: string) {
  const response = await Promise.all([apiBlob.get(`/user-cases/${id}/documents/${docId}/view`)]);
  return response;
}

export async function postDocument(name: string, data: string, id?: string) {
  const response = await Promise.all([
    api.post(`/user-cases/${id}/documents`, {
      name: name,
      data: data,
    }),
  ]);
  return response;
}

export async function deleteDocument(id?: string, docId?: string) {
  const response = await Promise.all([api.delete(`/user-cases/${id}/documents/${docId}`)]);
  return response;
}

//User Case Supports
export async function fetchUserCaseSupports(id?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/supports`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function patchSupportsData(support: object, id?: string, supportId?: string) {
  const response = await Promise.all([api.patch(`/user-cases/${id}/supports/${supportId}`, support)]);
  return response;
}

export async function postSupportsData(id?: string, support?: string) {
  const response = await Promise.all([api.post(`/user-cases/${id}/supports`, { user_id: support })]);
  return response;
}

export async function deleteSupports(id?: string, supportId?: string) {
  const response = await Promise.all([api.delete(`/user-cases/${id}/supports/${supportId}`)]);
  return response;
}

//User Case Supports Docs
export async function fetchSupportsRelease(id?: string, supportId?: string) {
  const response = await Promise.all([api.get(`/user-cases/${id}/supports/${supportId}/release`)]);
  return response;
}

export async function fetchSupportsReleaseDownload(id?: string, supportId?: string) {
  const response = await Promise.all([apiBlob.get(`/user-cases/${id}/supports/${supportId}/release/download`)]);
  return response;
}

export async function postSupportsRelease(name: string, data: string, id?: string, supportId?: string) {
  const response = await Promise.all([
    api.post(`/user-cases/${id}/supports/${supportId}/release`, {
      name: name,
      data: data,
    }),
  ]);
  return response;
}

export async function deleteSupportsRelease(id?: string, supportId?: string) {
  const response = await Promise.all([api.delete(`/user-cases/${id}/supports/${supportId}/release`)]);
  return response;
}

//User Case Goals
export async function fetchGoals(id?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/goals`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function patchGoal(goal: object, id?: string, goalId?: string) {
  const response = await Promise.all([api.patch(`/user-cases/${id}/goals/${goalId}`, goal)]);
  return response;
}

export async function postGoal(goal: object, id?: string) {
  const response = await Promise.all([api.post(`/user-cases/${id}/goals`, goal)]);
  return response;
}

export async function deleteGoal(id?: string, goalId?: string) {
  const response = await Promise.all([api.delete(`/user-cases/${id}/goals/${goalId}`)]);
  return response;
}

//User Case Goal Tasks
export async function patchTask(task: object, id?: string, goalId?: string, taskId?: string) {
  const response = await Promise.all([api.patch(`/user-cases/${id}/goals/${goalId}/tasks/${taskId}`, task)]);
  return response;
}

export async function postTask(task: object, id?: string, goalId?: string) {
  const response = await Promise.all([api.post(`/user-cases/${id}/goals/${goalId}/tasks`, task)]);
  return response;
}

export async function deleteTask(id?: string, goalId?: string, taskId?: string) {
  const response = await Promise.all([api.delete(`/user-cases/${id}/goals/${goalId}/tasks/${taskId}`)]);
  return response;
}

export async function fetchNextTasks(id?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/next-tasks`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

//User Case Assessments
export async function fetchAssessmentTypes() {
  const response = await Promise.all([
    api.get(`/assessmenttypes`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
      throw error;
    }),
  ]);
  return response;
}

export async function fetchAssessments(id?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/assessments`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
      throw error;
    }),
  ]);
  return response;
}

export async function fetchAssessment(id?: string, assessId?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/assessments/${assessId}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function postAssessment(assess: object, id?: string) {
  const response = await Promise.all([api.post(`/user-cases/${id}/assessments`, assess)]);
  return response;
}

export async function patchAssessment(subject: object, id?: string, assessId?: any) {
  const response = await Promise.all([api.patch(`/user-cases/${id}/assessments/${assessId}`, { subject: subject })]);
  return response;
}

//User Case Convesations
export async function fetchConversations(id?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/conversations`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function postConversation(conv: object, id?: string) {
  const response = await Promise.all([api.post(`/user-cases/${id}/conversations`, conv)]);
  return response;
}

//User Case Convesations / Messages
export async function fetchMessages(id?: string, convId?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/conversations/${convId}/messages`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchAddlMessages(id?: string, convId?: string, firstId?: string) {
  const response = await Promise.all([
    api.get(`/user-cases/${id}/conversations/${convId}/messages?firstID=${firstId}`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function postNewMessage(message: object, id?: string, convId?: string) {
  const response = await Promise.all([api.post(`/user-cases/${id}/conversations/${convId}/messages`, message)]);
  return response;
}

//User Case Notes Magic Summary
export async function fetchSummary(id?: string) {
  const response = await Promise.all([api.get(`/user-cases/${id}/summary`).catch((error) => {})]);
  return response;
}

export async function postSummary(id?: string) {
  const response = await Promise.all([api.post(`/user-cases/${id}/summary`).catch((error) => {})]);
  return response;
}

///Dropdowns
export async function fetchRelationships() {
  const response = await Promise.all([api.get(`/relationships`)]);
  return response;
}

export async function fetchGenders() {
  const response = await Promise.all([api.get(`/genders`)]);
  return response;
}

export async function fetchRaces() {
  const response = await Promise.all([api.get(`/races`)]);
  return response;
}

export async function fetchEthnicities() {
  const response = await Promise.all([api.get(`/ethnicities`)]);
  return response;
}

export async function fetchSupportTypes() {
  const response = await Promise.all([api.get(`/supporttypes`)]);
  return response;
}

export async function fetchCaseStatuses() {
  const response = await Promise.all([api.get(`/casestatuses`)]);
  return response;
}

export async function fetchRoles(isHMIS: boolean) {
  var response;
  if (isHMIS) {
    response = await Promise.all([api.get(`/userroles?isHMIS=${isHMIS}`)]);
  } else {
    response = await Promise.all([api.get(`/userroles`)]);
  }
  return response;
}

///User Impersonation
export async function fetchUserImpersonation(authCode: string) {
  const response = await Promise.all([api.get(`/user-impersonations?authCode=${authCode}`)]);
  return response;
}

///Magic Links
export async function consumeMagicLink(token: string) {
  const response = await Promise.all([api.get(`/magic-links/consume`, { params: { token } })]);
  return response;
}

export async function patchUserImpersonation(id: string) {
  const response = await Promise.all([api.patch(`/user-impersonations/${id}`)]);
  return response;
}

//Bed Management / Rooms
export async function fetchRooms() {
  const response = await Promise.all([
    api.get(`/rooms`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function patchRoom(room: object, roomId: string) {
  const response = await Promise.all([api.patch(`/rooms/${roomId}`, room)]);
  return response;
}

export async function postRoom(room: object) {
  const response = await Promise.all([api.post(`/rooms`, room)]);
  return response;
}

export async function deleteRoom(roomId: string) {
  const response = await Promise.all([api.delete(`/rooms/${roomId}`)]);
  return response;
}

export async function fetchBeds() {
  const response = await Promise.all([
    api.get(`/beds`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function patchBed(bed: object, bedId: string) {
  const response = await Promise.all([api.patch(`/beds/${bedId}`, bed)]);
  return response;
}

export async function postBed(bed: object) {
  const response = await Promise.all([api.post(`/beds`, bed)]);
  return response;
}

export async function deleteBed(bedId: string) {
  const response = await Promise.all([api.delete(`/beds/${bedId}`)]);
  return response;
}

//Dwelling Management
export async function fetchDwellingTypes() {
  const response = await Promise.all([
    api.get(`/dwelling-types`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function fetchDwellings() {
  const response = await Promise.all([
    api.get(`/dwellings`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function patchDwelling(dwelling: object, dwellingId: string) {
  const response = await Promise.all([api.patch(`/dwellings/${dwellingId}`, dwelling)]);
  return response;
}

export async function postDwelling(dwelling: object) {
  const response = await Promise.all([api.post(`/dwellings`, dwelling)]);
  return response;
}

export async function deleteDwelling(dwellingId: string) {
  const response = await Promise.all([api.delete(`/dwellings/${dwellingId}`)]);
  return response;
}

//Facility Management
export async function fetchFacilities() {
  const response = await Promise.all([
    api.get(`/facilities`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function patchFacility(facility: object, facilityId: string) {
  const response = await Promise.all([api.patch(`/facilities/${facilityId}`, facility)]);
  return response;
}

export async function postFacility(facility: object) {
  const response = await Promise.all([api.post(`/facilities`, facility)]);
  return response;
}

export async function deleteFacility(facilityId: string) {
  const response = await Promise.all([api.delete(`/facilities/${facilityId}`)]);
  return response;
}

export async function fetchPossibleBedOccupants() {
  const response = await Promise.all([api.get(`/beds/0/occupants`)]);
  return response;
}

//Bed Occupancy Check
export async function fetchBedChecks() {
  const response = await Promise.all([
    api.get(`/bed-checks`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function postBedCheck(bed: object) {
  const response = await Promise.all([api.post(`/bed-checks`, bed)]);
  return response;
}

export async function updateConsecutiveCount(bed: object) {
  const response = await Promise.all([api.patch(`/bed-checks/check`, bed)]);
  return response;
}

//Bed Inspections
export async function fetchLastBedInspection(roomId?: any) {
  const response = await Promise.all([
    api.get(`/bed-inspections`, { params: { room: roomId } }).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
      throw error;
    }),
  ]);
  return response;
}

export async function fetchLastBedInspectionAll(roomIds?: any) {
  const response = await Promise.all([
    api.post(`/bed-inspections/all`, { rooms: roomIds }).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function postBedInspection(inspection: any) {
  const response = await Promise.all([api.post(`/bed-inspections`, inspection)]);
  return response;
}

///Bed Occupant Assignments
export async function postBedOccupant(b: object, id?: string) {
  const response = await Promise.all([api.post(`/user-cases/${id}/bed-occupants`, b)]);
  return response;
}

export async function patchBedOccupant(id?: string, bedOccupantId?: string) {
  const response = await Promise.all([api.patch(`/user-cases/${id}/bed-occupants/${bedOccupantId}`)]);
  return response;
}

///Room Occupant Assignments
export async function postRoomOccupant(b: object, id?: string) {
  const response = await Promise.all([api.post(`/user-cases/${id}/room-occupants`, b)]);
  return response;
}

export async function patchRoomOccupant(id?: string, roomOccupantId?: string) {
  const response = await Promise.all([api.patch(`/user-cases/${id}/room-occupants/${roomOccupantId}`)]);
  return response;
}

///Dwelling Occupant Assignments
export async function postDwellingOccupant(b: object, id?: string) {
  const response = await Promise.all([api.post(`/user-cases/${id}/dwelling-occupants`, b)]);
  return response;
}

export async function patchDwellingOccupant(id?: string, dwellingOccupantId?: string) {
  const response = await Promise.all([api.patch(`/user-cases/${id}/dwelling-occupants/${dwellingOccupantId}`)]);
  return response;
}

///Housing Candidates (cases eligible for room/dwelling/bed assignment)
export async function fetchHousingCandidates() {
  const response = await Promise.all([api.get(`/housing-candidates`)]);
  return response;
}

//Check In Out
export async function fetchCheckInOut() {
  const response = await Promise.all([
    api.get(`/check-in`).catch((error) => {
      if (error.response.status === 401) {
        logout().then((res: any) => {
          window.location.reload();
        });
      }
    }),
  ]);
  return response;
}

export async function patchCheckInOut(c: object, checkId: number) {
  const response = await Promise.all([api.patch(`/check-in/${checkId}`, c)]);
  return response;
}

export async function postCheckIn(c: object) {
  const response = await Promise.all([api.post(`/check-in`, c)]);
  return response;
}

//////////////////////////////////////////////////////////
